class MobileMenu extends HTMLElement {
  handleSummaryClick = (e) => {
    e.preventDefault();
    this._toggle();
  };

  closeEsc = (e) => {
    // A modal opened from the menu (the country selector) closes on its own,
    // leaving the menu open behind it.
    if (e.target.closest?.("markup-modal")) return;

    if (e.key === "Escape" && this.classList.contains("open")) {
      this._close();
    }
  };

  handleResize = () => {
    if (!this._isMobile && this.details.open) {
      this._forceClose();
    }

    this._setMaxHeightVariable();
  };

  connectedCallback() {
    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");

    if (!this.summary || !this.details) return;

    this.summary.addEventListener("click", this.handleSummaryClick);
    document.addEventListener("keydown", this.closeEsc);
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    this.summary?.removeEventListener("click", this.handleSummaryClick);
    document.removeEventListener("keydown", this.closeEsc);
    window.removeEventListener("resize", this.handleResize);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _forceClose() {
    this.classList.remove("open");
    this.details.open = false;
    window.closeDimmer(this);
    window.removeTrapFocus(this.summary);
    window.unlockScroll(this);
    this.removeEventListener("transitionend", this.onEnd);
  }

  _open() {
    this.details.open = true;
    window.requestAnimationFrame(() => {
      this.classList.add("open");
      this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      window.lockScroll(this);
      window.openDimmer(this);
      this.style.setProperty(
        "--mobile-menu-top",
        `${this.closest(".header").getBoundingClientRect().bottom}px`,
      );
      this._setMaxHeightVariable();
    });
    window.trapFocus(this.details);
  }

  _close() {
    this.classList.remove("open");
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    const onEnd = (e) => {
      if (!("mobileMenuDrawer" in e.target.dataset)) return;

      this.removeEventListener("transitionend", onEnd);

      if (this.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary);
      window.unlockScroll(this);
      window.closeDimmer(this);
      this.dispatchEvent(
        new CustomEvent("mobile-menu:closed", { bubbles: true }),
      );
    };
    this.addEventListener("transitionend", onEnd);
  }

  _setMaxHeightVariable() {
    const container = this.querySelector(".header__mobile-menu-content");
    if (!container) return;

    const { height } = container.getBoundingClientRect();
    this.style.setProperty("--mobile-menu-max-content-height", `${height}px`);
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}
